import React from "react";
import { STEPS } from "./courseData";

const LanguageLandingSteps = () => {
  return (
    <section id="ll-how-it-works" className="ll-section ll-steps">
      <div className="container">
        <header className="section-header wow fadeInUp">
          <span className="ll-section-label ll-section-label--light">How It Works</span>
          <h2 className="about_head ll-steps__title">
            Start Learning in{" "}
            <span className="highlighted-text">3 Simple Steps</span>
          </h2>
          <p className="ll-section-subtitle ll-section-subtitle--light">
            From demo to certification — we make the journey simple and
            stress-free.
          </p>
        </header>

        <div className="ll-steps-grid">
          {STEPS.map((step, index) => (
            <div
              key={step.number}
              className="ll-step-card wow fadeInUp"
              data-wow-delay={`${index * 0.15}s`}
            >
              <div className="ll-step-card__number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LanguageLandingSteps;
